import { request } from './http';
import type { LoginParams, LoginResult, User } from '@/types/api';

export const login = (data: LoginParams) =>
  request<LoginResult>({
    url: '/api/auth/login',
    method: 'POST',
    data,
  });

export const getCurrentUser = () =>
  request<User>({
    url: '/api/me',
    method: 'GET',
  });
